module.exports = __webpack_public_path__ + "static/media/squared.9eb024c1.jpg";